export default __webpack_public_path__ + "static/media/ricevuta_acquisto_smartphonecash_-08.b61d1691.svg";